import {loadFont} from '@remotion/google-fonts/Inter';

const {fontFamily} = loadFont();

export const brand = {
  bg: '#0A0A0A',
  bgGradientEnd: '#1A1A2E',
  card: '#1A1A1A',
  surface: '#141414',
  input: '#262626',

  primary: '#8B5CF6',
  primaryLight: '#A78BFA',
  primaryDark: '#7C3AED',
  secondary: '#6366F1',
  accent: '#F472B6',
  action: '#F97316',

  textPrimary: '#FFFFFF',
  textSecondary: '#A1A1AA',
  textMuted: '#71717A',

  success: '#22C55E',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',

  timerWork: '#8B5CF6',
  timerRest: '#F59E0B',
  timerCountdown: '#F59E0B',
  timerComplete: '#22C55E',
  timerStop: '#FF5151',

  border: '#27272A',
  borderLight: '#3F3F46',
} as const;

export const brandFont = fontFamily;

export const brandGradient = `linear-gradient(135deg, ${brand.primary} 0%, ${brand.secondary} 100%)`;
export const bgGradient = `linear-gradient(180deg, ${brand.bg} 0%, ${brand.bgGradientEnd} 100%)`;
export const actionGradient = `linear-gradient(135deg, ${brand.action} 0%, #FB923C 100%)`;
export const accentGradient = `linear-gradient(135deg, ${brand.accent} 0%, #EC4899 100%)`;

export const FORMAT = {
  reel: {width: 1080, height: 1920},
  square: {width: 1080, height: 1080},
  portrait: {width: 1080, height: 1350},
  landscape: {width: 1920, height: 1080},
  landscapeHD: {width: 1280, height: 720},
  appStore: {width: 1080, height: 1920},
} as const;

export const FPS = 30;
